import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cards: {
    marginTop: 16,
    height: 'auto',
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))
